import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { IPrImprisonmentEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { SocialEventsFormViewForExtend } from "@pages/payroll/socialEvents/SocialEventsFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class ImprisonmentFormView extends SocialEventsFormViewForExtend<IPrImprisonmentEventEntity> {
    typeCode = PrSocialEventTypeCode.Imprisonment;
}

export default withPermissionContext(withConfirmationDialog(ImprisonmentFormView));